module.exports = __webpack_public_path__ + "img/VoIP.d8e06ff0.jpg";